var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page"},[_c('header',[_c('h1',[_vm._v("Unither Packaging")]),_c('router-link',{attrs:{"to":"/orders"}},[_vm._v("Work Orders")])],1),_c('section')])}
var staticRenderFns = []

export { render, staticRenderFns }